import { Search } from '@/DTOS/TimeKeeperEntry/Search';
import request from '../../utils/request';

const TimeKeeperEntryService = {
  report: (search: Search) => {
    return request('/timeKeeperEntry/report', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  print: (specification: Search) => {
    return request(
      '/timeKeeperEntry/print',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ request: { ...specification } }),
      },
      true
    );
  },
};

export default TimeKeeperEntryService;
